
import styles from "../../../../AccountingPage.module.scss";
import { useEffect, useState } from 'react'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { getStudentsHistoryData } from "service/AccountingService";


const StudentHystoryContent = ({ render, setRender, id, datastudent }) => {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [datahistory, setDataHistory] = useState([]);
  const getDataHistory = async (id) => {
    try {
      let response = await getStudentsHistoryData(id, datahistory);
      setDataHistory(response.data);
    } catch (error) {
      console.log("onoxo")
    }
  };
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil(datahistory.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = datahistory.slice(indexOfFirstItem, indexOfLastItem);
  useEffect(() => {
    getDataHistory(id)
    setRender(false);

    // getData(id);


  }, [render]);

  return (
    <>

      <div className={styles.content_header} style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ width: "100%" }} className={styles.print_header_selection_shah}>
          <h3 className={styles.project__h}>Актуальные</h3>
          <hr style={{ borderTop: '2px solid #444', margin: '20px 0 0 0' }} />
          <table className={styles.table__wrapper}>
            <thead className={styles.table__head}>
              <tr className={styles.table__row}>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>ИНН</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Фамилия</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Имя</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Специальность</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Вид обучения</span>
                </th>
                <th className={styles.table__item_student}>
                  <span className={styles.table__title}>Курс </span>
                </th>
                <th className={styles.table__item_student}>
                  <span className={styles.table__title}>Статус </span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Дата и время</span>
                </th>
              </tr>
            </thead>
            <tbody className={styles.table__body}>
              <tr className={styles.table__row}>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.inn}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.surname}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.first_name}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.speciality_name}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.educationtype_name}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title} style={{ fontWeight: '700' }}>
                    {datastudent.course_name}
                  </span>
                </td>
                <td className={styles.table__item_contract}>
                  <span
                    className={styles.table__title}
                    style={{
                      fontWeight: '700',
                      padding: '5px',
                      borderRadius: '6px',
                      display: "block",
                      textAlign: "center",
                      background:
                        datastudent.status === 'Зачислен(а)' ? '#5C5CFF' :
                          datastudent.status === 'Отчислен(а)' ? '#a00000ff' :
                            datastudent.status === 'В академическом отпуске' ? '#ec9900ff' :
                              datastudent.status === 'Переведен(а)' ? '#333333' :
                                datastudent.status === 'Выпущен(а)' ? '#008000' :
                                  'transparent',
                      color: datastudent.status ? 'white' : 'inherit',
                    }}
                  >
                    {datastudent.status || ''}
                  </span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>
                    {new Date().toLocaleString("ru-RU", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <h3 className={styles.project__h}>История движения</h3>
          <hr style={{ borderTop: '2px solid #444', margin: '20px 0 0 0' }} />
        </div>



        <table ref={componentRef} className={styles.table__wrapper}>
          <thead className={styles.table__head}>
            <tr className={styles.table__row}>
              <th className={styles.table__item_student}>№</th>
              <th className={styles.table__item_student}>
                <span className={styles.table__title}>Учебный год</span>
              </th>
              <th className={styles.table__item_student}>
                <span className={styles.table__title}>Вид обучения </span>
              </th>
              <th className={styles.table__item_student}>
                <span className={styles.table__title}>Специальность </span>
              </th>
              <th className={styles.table__item_student}>
                <span className={styles.table__title}>Курс </span>
              </th>
              <th className={styles.table__item_student}>
                <span className={styles.table__title}>Приказ </span>
              </th>

              <th className={styles.table__item_student}>
                <span className={styles.table__title}>Статус </span>
              </th>
              <th className={styles.table__item_student} >
                <span className={styles.table__title}>Дата изменения</span>
              </th>
              <th className={styles.table__item_student} >
                <span className={styles.table__title}>Причина перемещения в архив</span>
              </th>
            </tr>
          </thead>

          <tbody className={styles.table__body}>
            {currentItems.map((item, index) => (

              <tr className={styles.table__row} key={item.id}>
                <td className={styles.table__item_student}>
                  <span className={styles.table__title}>
                    {index + 1 + (currentPage - 1) * itemsPerPage}
                  </span>
                </td>
                <td className={styles.table__item_student}>
                  <span className={styles.table__title} style={{ fontWeight: '700' }}>
                    {item.academic_year_name}
                  </span>
                </td>
                <td className={styles.table__item_student}>
                  <span className={styles.table__title} style={{ fontWeight: '700' }}>
                    {item.educationtype_name}
                  </span>
                </td>

                <td className={styles.table__item_student}>
                  <span className={styles.table__title} style={{ fontWeight: '700' }}>
                    {item.speciality_name}
                  </span>
                </td>
                <td className={styles.table__item_student}>
                  <span className={styles.table__title} style={{ fontWeight: '700' }}>
                    {item.course_name}
                  </span>
                </td>
                <td className={styles.table__item_student}>
                  <span className={styles.table__title} style={{ fontWeight: '700' }}>
                    {item.order}
                  </span>
                </td>
                <td className={styles.table__item_student}>
                  <span
                    className={styles.table__title}
                    style={{
                      fontWeight: '700',
                      padding: '5px',
                      borderRadius: '6px',
                      display: "block",
                      textAlign: "center",
                      background:
                        item.status === 'Зачислен(а)' ? '#5C5CFF' :
                          item.status === 'Отчислен(а)' ? '#a00000ff' :
                            item.status === 'В академическом отпуске' ? '#ec9900ff' :
                              item.status === 'Переведен(а)' ? '#333333' :
                                item.status === 'Выпущен(а)' ? '#008000' :
                                  'transparent',
                      color: item.status ? 'white' : 'inherit',
                    }}
                  >
                    {item.status || ''}
                  </span>
                </td>
                <td className={styles.table__item_student}>
                  <span className={styles.table__title} style={{ fontWeight: '700' }}>
                    {item.created_at}
                  </span>
                </td>
                <td className={styles.table__item_student}>
                  <span className={styles.table__title} style={{ fontWeight: '700' }}>
                    {item.description}
                  </span>
                </td>

              </tr>
            ))}

            {/* Итого */}

          </tbody>
          <div className={styles.pagination}>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                style={{
                  padding: '5px 10px',
                  background: currentPage === page ? '#736CED' : '#f0f0f0',
                  color: currentPage === page ? '#fff' : '#000',
                  border: '1px solid #ccc',
                  borderRadius: "6px",
                  cursor: 'pointer',
                }}
              >
                {page}
              </button>
            ))}
          </div>



        </table>
      </div>




    </>


  );
};

export default StudentHystoryContent;
